/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListCollapse = [
  ["path", { d: "M10 5h11" }],
  ["path", { d: "M10 12h11" }],
  ["path", { d: "M10 19h11" }],
  ["path", { d: "m3 10 3-3-3-3" }],
  ["path", { d: "m3 20 3-3-3-3" }]
];

export { ListCollapse as default };
//# sourceMappingURL=list-collapse.js.map
